import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField} from '@angular/material/form-field';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {DepartmentService, ReferenceService} from '../../../apiModule1';
import {AsyncPipe, JsonPipe, NgClass, NgStyle} from '@angular/common';
import {MatLabel, MatSelect} from '@angular/material/select';
import {MatInput} from '@angular/material/input';
import {map} from 'rxjs/operators';
import {MultiSelectComponent} from '../../../../shared/components/multi-select/multi-select.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {OnInputChange} from '../../OnInputChange';

@Component({
  selector: 'pas-filter-dialog-department',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatFormField,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatFormField,
    MatLabel,
    AsyncPipe,
    MatSelect,
    MatInput,
    MatButton,
    NgClass,
    NgStyle,
    MatDialogClose,
    MultiSelectComponent,
    MultiSelect2Component,
    JsonPipe
  ],
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss','../../index-entity/filter-dialog/filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDialogComponent implements OnInit {
  cdr = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<FilterDialogComponent>);
  referenceService = inject(ReferenceService);
  data: Record<string, any> = inject(MAT_DIALOG_DATA)
  departmentService = inject(DepartmentService);


  archiveStatuses: Status[] = []
  departments: Department[] = []

  form = new FormGroup({
    archive: new FormControl(this.data && this.data['statusIds'] || []),
    departments: new FormControl(this.data && this.data['departmentsIds'] || []),
  })

  dataDepartment: OnInputChange<Department>  = new OnInputChange(this.departmentService,'apiDepartmentFilterlistGet', 'department')

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    console.log('filter-dialog data', this.data);

    this.referenceService.apiReferenceStatusesGet().pipe(map(v => v.values)).subscribe((v: Status[]) => {
      this.archiveStatuses = v;
    })

    this.dataDepartment.on().subscribe(v => {
      this.departments = v;
      this.cdr.markForCheck();
    })

  }


  onReset(): void {
    this.form.reset();
  }

  onApply() {
    const res = {
      statusIds: this.form.get('archive')!.value,
      departmentIds: this.form.get('departments')!.value,
    }

    this.dialogRef.close(res);
  }

}


